export const storeModule = {
  address: "店铺住所",
  baseInfo: "基本情报",
  content: "内容",
  time: "营业时间",
  dateTime: "营业日",
  pickTime: "自提时间",
  devTime: "外卖时间",
  payFun: "支付方式",
  detail: "店铺详情",
  detailInfo: "店铺详细",
  devPrice: "配送费",
  minPrice: "最低消费金额",
  freePrice: "* 以上免配送费",
  freeDevPriceDiff: "还差*免配送费",
  freeDevPrice: "免配送费",
  leal: "特商法",
  lealTab1: "项目",
  lealTab2: "计入栏",
  lealTitle1: "商家名称(公司名、商号、店名)",
  lealTitle2: "商家地址",
  lealTitle3: "代表人或经营责任人",
  lealTitle4: "代表人或经营责任人(假名)",
  lealTitle5: "联系地址/官网",
  lealTitle6: "联系地址/邮箱",
  lealTitle7: "联系地址/电话",
  lealTitle8: "商品价格区间",
  lealTitle9: "交货时间、发货方式",
  lealTitle10: "支付时间和支付方式",
  lealTitle11: "除商品价格之外的必须费用/配送费、手续费、消费税等",
  lealTitle12: "退货的条件/退货期限、退货时产生的配送费或中途解约、退会的条件",
  lealTitle13: "瑕疵品的处理办法",
  shopTimeOuter1: "受理中止",
  shopTimeOuter2: "不在受理时间内",
  shopTimeOuterSm1: "準備中",//休止中
  shopTimeOuterSm2: "时间外",
  orderSm1: "可预约",
  orderDayBefore: "*天前",
  noText: "无",
  storeRemark: "店铺一言",
  devDistanceNo: "目前的配送地址不在店铺配送范围内。请选择其他店铺",
  devSearch: "搜索",
  devNoAddress: "请使用以下任意一种方法设置收货地址"
};
export const evaluationModule = {
  star: "满足度",
  contentHolder: "请留言",
  noStar: "请选择满意度",
  noContent: "评论内容不能为空",
  submitSuccess: "评价成功",
  replay: "商家回复",
  uploadSuccess: "上传成功"
};
